"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { getTimeAgo } from "@/helpers/Helpers";
import { useContext } from "react";
import { AuthContext } from "@/components/auth/Auth";
import GroupCardEditActions from "./actions/GroupCardEditActions";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
export default function GroupCardHeader(t0) {
  const $ = _c(25);
  const {
    group,
    onEditClick,
    userPlaceholder
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  let t1;
  if ($[0] !== group) {
    t1 = group ? getTimeAgo(new Date(group.created_at ?? "").getTime()) : "";
    $[0] = group;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const timeAgo = t1;
  let t2;
  if ($[2] !== group) {
    t2 = <div className="-tw-mt-3 tw-flex tw-gap-x-4">{group?.created_by.pfp ? <img className="tw-flex-shrink-0 tw-object-contain tw-h-9 tw-w-9 tw-rounded-md tw-bg-iron-700 tw-ring-1 tw-ring-iron-700" src={getScaledImageUri(group.created_by.pfp, ImageScale.W_AUTO_H_50)} alt="Profile Picture" /> : <div className="tw-h-9 tw-w-9 tw-rounded-md tw-bg-iron-700 tw-ring-1 tw-ring-iron-700" />}</div>;
    $[2] = group;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = group ? `/${group?.created_by.handle ?? userPlaceholder}` : userPlaceholder ?? "";
  const t4 = group?.created_by.handle ?? userPlaceholder;
  let t5;
  if ($[4] !== t4) {
    t5 = <span className="tw-text-sm tw-font-semibold">{t4}</span>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t5) {
    t6 = <Link onClick={_temp} href={t3} className="tw-relative tw-z-20 tw-no-underline hover:tw-underline tw-transition tw-duration-300 tw-ease-out  tw-text-iron-50 hover:tw-text-iron-400">{t5}</Link>;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== timeAgo) {
    t7 = <span className="tw-text-sm tw-text-iron-500 tw-font-normal">{timeAgo}</span>;
    $[9] = timeAgo;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== activeProfileProxy || $[12] !== connectedProfile?.handle || $[13] !== group || $[14] !== onEditClick) {
    t8 = !!connectedProfile?.handle && !activeProfileProxy && onEditClick && group && <GroupCardEditActions group={group} onEditClick={onEditClick} />;
    $[11] = activeProfileProxy;
    $[12] = connectedProfile?.handle;
    $[13] = group;
    $[14] = onEditClick;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = <div className="tw-flex tw-items-center tw-gap-x-4">{t7}{t8}</div>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t6 || $[20] !== t9) {
    t10 = <div className="tw-mt-1.5 tw-flex tw-items-center tw-w-full tw-justify-between">{t6}{t9}</div>;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t2) {
    t11 = <div className="tw-px-4 sm:tw-px-5 tw-flex tw-items-center tw-gap-x-3">{t2}{t10}</div>;
    $[22] = t10;
    $[23] = t2;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}
function _temp(e) {
  return e.stopPropagation();
}